module.exports = "/build/web/svg/sponsor/unique.9b5168f1507d88f7ae5fbf9d7d80597b.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/unique.svg
// module id = 222
// module chunks = 24